import { render, staticRenderFns } from "./Related.vue?vue&type=template&id=a9f0a2e8"
import script from "./Related.vue?vue&type=script&lang=js"
export * from "./Related.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports